export function handleNewsletterFormSubmit () {
  const form = document.querySelector('[data-newsletter-form]')
  if (form) {
    form.addEventListener('submit', function () {
      form.validator.validateForm().then(function (formData) {
        const submitBtn = form.querySelector('button[type="submit"]')
        if (submitBtn && typeof (submitBtn.loadingButtonInstance) !== 'undefined') {
          submitBtn.loadingButtonInstance.toggle()
        }
      }).catch(function (errors, fields) {
      })
    })
  }
}
